import React, { useState } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { handleChangeUsername, handleChangePassword, USER_DISABLED_KASEYA_ONE_ERROR } from '@app/helpers';
import { ButtonSubmit, ErrorBlock, CompanyLogo, PasslyTextField} from '@app/components';
import { ICredentials, TranslationsTypes } from '@app/models';

interface IProps {
    signinForNotLinkedUser: (username: string, password: string) => void;
    isLoading: boolean;
    errorKaseyaOneCode: string;
}

export const SignInKaseyaOneCreds: React.SFC<IProps> = ({ signinForNotLinkedUser, isLoading, errorKaseyaOneCode }) => {
    const [credentials, setCredentials] = useState<ICredentials>({ username: '', password: '' });
    const [emptyUsernameError, setEmptyUsernameError] = useState(false);
    const [emptyPasswordError, setEmptyPasswordError] = useState(false);
    const { translation } = useTypedTranslation();
    const { username, password } = credentials;

    const errorCode = errorKaseyaOneCode !== USER_DISABLED_KASEYA_ONE_ERROR && errorKaseyaOneCode ? errorKaseyaOneCode : '';

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (username && password) {
            signinForNotLinkedUser(username, password);
        }

        setEmptyUsernameError && setEmptyUsernameError(!username);
        setEmptyPasswordError(!password);
    };

    return (
        <>
            <CompanyLogo />
            <form className='loginKaseyaOne__form' onSubmit={handleSubmit}>
                <div className='loginKaseyaOne__form-text'>{translation('KASEYA_ONE_LINKING_TEXT_1')}</div>
                <div className='loginKaseyaOne__form-text'>{translation('KASEYA_ONE_LINKING_TEXT_2')}</div>
                <ErrorBlock className='loginKaseyaOne__error' isError={!!errorCode} errorCode={errorCode as TranslationsTypes} />
                <div className='form__row'>
                    <PasslyTextField
                        fullWidth
                        label={'USERNAME'}
                        value={username}
                        onChange={handleChangeUsername(setCredentials)}
                        id='userName-input'
                        error={emptyUsernameError}
                        helperText={emptyUsernameError ? translation('EMPTY_FIELD_ERROR') : ''}
                        autoFocus />
                </div>

                <div className='form__row'>
                    <PasslyTextField
                        fullWidth
                        label={'PASSWORD'}
                        value={password}
                        onChange={handleChangePassword(setCredentials)}
                        type='password'
                        id='userPassword-input'
                        error={emptyPasswordError}
                        helperText={emptyPasswordError ? translation('EMPTY_FIELD_ERROR') : ''}
                        />
                </div>

                <div className='loginKaseyaOne__buttons'>
                    <ButtonSubmit
                        className='loginKaseyaOne__buttons-login-button'
                        isDisabled={isLoading}
                        isLoad={isLoading}
                        buttonText={translation('KASEYA_ONE_ENABLE')}
                        id='signinKaseyaOne'
                        disableRipple={true}
                    />
                </div>
            </form>
        </>
    );
};
